var map = {
	"./chaos_small.jpg": "8ffd",
	"./corrupted_small.jpg": "ded4",
	"./elemental_small.jpg": "652f",
	"./high_elf_small.jpg": "c358",
	"./human_small.jpg": "2ef7",
	"./mech_small.jpg": "4405",
	"./naga_small.jpg": "efea",
	"./nature_small.jpg": "b47c",
	"./night_elf_small.jpg": "42b3",
	"./north_small.jpg": "038c",
	"./orc_small.jpg": "c1ce",
	"./undead_small.jpg": "b5ad",
	"./wisp_small.jpg": "c825"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3070";